var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{staticClass:"mapboxgl-ctrl",staticStyle:{"width":"10em"},attrs:{"id":"Basemap","options":_vm.basemaps},model:{value:(_vm.basemap),callback:function ($$v) {_vm.basemap=$$v},expression:"basemap"}})}
var staticRenderFns = []

export { render, staticRenderFns }